/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { Skeleton } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/common/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-software-company-managed-project-settings" */ './main.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncSidebar = ({ project }: Props): React.JSX.Element => (
	<SidebarBoundary
		id="nav4.sidebar.project-settings.software.company-managed"
		packageName="jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
		ufoName="nav4.sidebar.project-settings.software.company-managed"
	>
		<Placeholder
			name="nav4.sidebar.project-settings.software.company-managed"
			fallback={<Skeleton />}
		>
			<LazySidebarContent project={project} />
		</Placeholder>
	</SidebarBoundary>
);

const ExportedComponent: React.MemoExoticComponent<({ project }: Props) => React.JSX.Element> =
	memo(AsyncSidebar);
export default ExportedComponent;
